export default __webpack_public_path__ + "static/media/contactImage.741b53de.jpg";